import { Component } from '@angular/core';

@Component({
  selector: 'app-null-component',
  templateUrl: './null.component.html',
  styleUrls: ['./null.component.scss'],
  standalone: true,
})
export class NullComponent {}
